import Icon from '../components/Icon.vue'

Icon.register({
  'comments-dollar': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M416 192C416 103.6 322.9 32 208 32S0 103.6 0 192C0 226.3 14.1 257.9 38 284 24.6 314.2 2.5 338.2 2.2 338.5A8-8 0 0 1 8 352C44.6 352 74.9 339.8 96.7 327 128.9 342.8 167 352 208 352 322.9 352 416 280.4 416 192zM192 288V271.7C180.7 271.1 169.7 267.2 160.6 260.4 156.7 257.4 156.5 251.6 160.1 248.2L171.8 237C174.6 234.4 178.7 234.3 181.9 236.3 185.8 238.7 190.2 240 194.8 240H222.9C229.4 240 234.7 234.1 234.7 226.8 234.7 220.9 231.1 215.6 225.9 214.1L180.9 200.6C162.3 195 149.3 177.2 149.3 157.2 149.3 132.7 168.4 112.8 192 112.1V96C192 91.6 195.6 88 200 88H216C220.4 88 224 91.6 224 96V112.3C235.3 112.9 246.3 116.8 255.4 123.6 259.3 126.6 259.5 132.4 255.9 135.8L244.2 147C241.4 149.6 237.3 149.8 234.1 147.7 230.2 145.3 225.8 144 221.2 144H193.1C186.6 144 181.3 149.9 181.3 157.2 181.3 163.1 184.9 168.4 190.1 169.9L235.1 183.4C253.7 189 266.7 206.8 266.7 226.8 266.7 251.3 247.6 271.2 224 271.9V288C224 292.4 220.4 296 216 296H200C195.6 296 192 292.4 192 288zM538 412C561.9 386 576 354.3 576 320 576 253.1 522.5 195.8 446.7 171.9 447.5 178.5 448 185.2 448 192 448 297.9 340.3 384 208 384 197.2 384 186.7 383.2 176.3 382.1 207.8 439.6 281.8 480 368 480 409 480 447.1 470.8 479.3 455 501.1 467.8 531.4 480 568 480 571.2 480 574.1 478.1 575.3 475.2 576.6 472.2 576 468.8 573.8 466.5 573.5 466.2 551.4 442.3 538 412z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comments-dollar.js
// module id = NwNt
// module chunks = 144